import React from 'react';
import { FiTarget, FiActivity, FiCpu, FiGlobe, FiSmile } from 'react-icons/fi';
import { Container } from '../../components/layout/Container';

const GoalItem = ({ goal, index }) => {
  const icons = [FiActivity, FiCpu, FiGlobe, FiSmile];
  const Icon = icons[index % icons.length];

  return (
    <div className="group flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm border border-blue-50 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-default">
      <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center text-primary flex-shrink-0 group-hover:scale-110 group-hover:bg-primary group-hover:text-white transition-all duration-300">
        <Icon size={20} />
      </div>
      <span className="text-gray-700 font-medium group-hover:text-primary transition-colors duration-300">{goal}</span>
    </div>
  );
};

/**
 * Vision section component for About page
 */
export const VisionSection = ({ vision }) => {
  return (
    <section className="py-16 md:py-24 bg-blue-50/30 relative overflow-hidden" aria-labelledby="vision-title">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl opacity-60 translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-primary/5 rounded-full blur-2xl opacity-60 -translate-x-1/2 translate-y-1/2" />

      <Container className="relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">



          {/* Visual Decor (Right on Desktop, Top on Mobile) */}
          <div className="lg:order-last relative h-[400px] lg:h-[500px] rounded-3xl overflow-hidden shadow-2xl group">
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent z-10" />
            <img
              src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
              alt="Vision"
              className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute bottom-8 left-8 right-8 z-20 text-white">
              <div className="text-2xl font-bold leading-tight">Shaping the Future of Logistics</div>
            </div>
          </div>

          {/* Content (Left on Desktop, Bottom on Mobile) */}
          <div className="lg:order-first">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-sm mb-6 text-primary">
              <FiTarget size={32} />
            </div>
            <h2 id="vision-title" className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-6">
              {vision.title}
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              {vision.content}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {vision.goals.map((goal, index) => (
                <GoalItem key={index} goal={goal} index={index} />
              ))}
            </div>
          </div>

        </div>
      </Container>
    </section>
  );
};

